import { render, staticRenderFns } from "./ProductTitle.vue?vue&type=template&id=1330ba98"
import script from "./ProductTitle.vue?vue&type=script&lang=js"
export * from "./ProductTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports